import { render } from "./monitorData.vue?vue&type=template&id=4885461d&scoped=true"
import script from "./monitorData.vue?vue&type=script&lang=js"
export * from "./monitorData.vue?vue&type=script&lang=js"

import "./monitorData.vue?vue&type=style&index=0&id=4885461d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4885461d"]])

export default __exports__